import React from 'react';
import { Spin } from 'antd';

const RuntimeLoadingState = ({ tip = 'Carregando dados do runtime...', minHeight = 180 }) => {
  return (
    <div
      style={{
        minHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spin tip={tip} />
    </div>
  );
};

export default RuntimeLoadingState;